var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4032 1.25555C14.9027 1.41302 15.2424 1.87627 15.2424 2.40004V8.40004L20.0424 8.40004C20.4898 8.40004 20.9001 8.64899 21.1068 9.04587C21.3134 9.44275 21.2821 9.92163 21.0255 10.2882L12.6255 22.2882C12.3251 22.7173 11.7812 22.902 11.2816 22.7445C10.7821 22.5871 10.4424 22.1238 10.4424 21.6L10.4424 15.6H5.64239C5.19494 15.6 4.78465 15.3511 4.57801 14.9542C4.37137 14.5573 4.40271 14.0784 4.65931 13.7119L13.0593 1.71188C13.3597 1.2828 13.9036 1.09809 14.4032 1.25555Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapWhiteIcon);
export default __webpack_public_path__ + "static/media/zap-white-icon.df49372d6422a6bdc0540bbd303e3d58.svg";
export { ForwardRef as ReactComponent };